import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import ModalContentBase from "../modal_content_base";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    type: PropTypes.string,
  },
  render() {
    let color = "";
    let title = "";
    let description = "";
    switch (this.props.type) {
      case "is_active_by_event_participated":
        color = "color-main";
        title = "アクティブイベンター";
        description =
          "サークルイベントへ積極的に参加しているユーザーへ贈られるリボンです。";
        break;
      case "is_active_by_viewed":
        color = "color-blue";
        title = "アクティブビュワー";
        description =
          "サークルページを定期的にチェックしているユーザーへ贈られるリボンです。";
        break;
    }
    const previewContent = (
      <span className={`${color} mr5 cursor-pointer`}>
        <i className="fas fa-ribbon" />
      </span>
    );

    const modalContent = (
      <div>
        <div className="modal-view-header">
          <p style={{ margin: "0 0 6px", padding: "1.5em", textAlign: "left" }}>
            <strong>
              <span className={`${color} mr5`}>
                <i className="fas fa-ribbon" />
              </span>
              {title}のリボン
            </strong>
          </p>
        </div>
        <div
          className="modal-view-body"
          style={{ padding: "0px 25px 50px", textAlign: "left" }}
        >
          <p>{description}</p>
        </div>
        <div className="modal-view-footer" />
      </div>
    );

    return (
      <div>
        <ModalContentBase
          previewContent={previewContent}
          modalContent={modalContent}
        />
      </div>
    );
  },
});
